import { app } from '../../../../app';
import { Controller } from './add-new-administrator.controller';

app.component('addNewAdministrator', {
    bindings: {
        administrators: '<',
        applications$: '<',
        appTypes$: '<',
        companyId: '<',
        email: '<',
        groups$: '<',
    },
    controller: Controller,
    templateUrl: require('./add-new-administrator.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/add/add-new-administrator.component.js